import ModelUtil from '@leverege/model-util';
import i18n from '@leverege/i18n';
const {
  tf
} = i18n.ns('ui-attributes.detail.customText.customTextDetailModel');
const TYPE = 'customText.detail';
function create() {
  return {
    type: TYPE,
    html: '<h1>Hi,</h1><h2>With this editor</h2><h3>you can do various headers</h3><p>and <strong>bold</strong>, <em>Italicize</em>, <s>strikethrough,</s> <span style="color: #e80909">color </span>text and more!</p>'
  };
}
const TestDetailModel = {
  TYPE,
  create,
  getName: tf('name'),
  ...ModelUtil.createAllValue('html')
};
export default TestDetailModel;